import { DEFAULT_SEARCH_API_URL } from './constants';
import { useAxios } from './useAxios';

export type GraphRequestType = {
  /**
   * GraphQL query OR mutation
   */
  query: string;
  variables?: Record<string, any>;
};

export const useGraphRequest = <ResponseData = any>(
  param: GraphRequestType,
  url: string,
  options?: {
    manual?: boolean;
    autoCancel?: boolean;
    useCache?: boolean;
  }
) => {
  return useAxios<ResponseData>({
    url,
    method: 'POST',
    data: param,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      accept: 'application/json',
    },
  }, options);
};

export const useSearchApi = <ResponseData = any>(
  param: GraphRequestType,
  url = DEFAULT_SEARCH_API_URL,
  options?: {
    manual?: boolean;
    autoCancel?: boolean;
    useCache?: boolean;
  }
) => {
  return useGraphRequest<ResponseData>(param, url, options);
};
